module.exports = __webpack_public_path__ + "static/media/Solomon Sikhosana.cd3ac968.jpg";